<template>
  <div class="forgot-password-container">
    <header class="login-header">
      <div class="container">
        <!-- logo svg 可复用 -->
      </div>
    </header>
    <main class="container">
      <div class="login-card">
        <router-link to="/login" class="back-link">
          <i class="fas fa-arrow-left"></i> Back to sign in
        </router-link>
        <h1 class="login-title">Forgot your password?</h1>
        <p class="login-subtitle">Enter your email and we'll send you a link to reset your password.</p>
        <form @submit.prevent="handleReset">
          <div class="form-group">
            <label for="email">Email</label>
            <input type="email" id="email" v-model="email" :class="{ 'border-red-500': errors.email }" placeholder="you@example.com" />
            <span class="error-message" v-if="errors.email">{{ errors.email }}</span>
          </div>
          <div class="error-message mt-4 mb-6" v-if="errorMessage">{{ errorMessage }}</div>
          <div class="text-green-600 mt-4 mb-6" v-if="successMessage">{{ successMessage }}</div>
          <button type="submit" class="btn btn-primary" :disabled="loading">
            <span v-if="loading">Sending...</span>
            <span v-else>Send reset link</span>
          </button>
        </form>
      </div>
    </main>
    <footer class="container">
      <div class="footer-links">
        <a href="https://stripe.com/docs" class="footer-link" target="_blank">Documentation</a>
        <a href="https://stripe.com/support" class="footer-link" target="_blank">Support</a>
        <a href="https://stripe.com/privacy" class="footer-link" target="_blank">Privacy</a>
        <a href="https://stripe.com/terms" class="footer-link" target="_blank">Terms</a>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { ref, inject } from 'vue';
const email = ref('');
const errors = ref({});
const loading = ref(false);
const successMessage = ref('');
const errorMessage = ref('');
const apiClient = inject('$apiClient');

function validateForm() {
  errors.value = {};
  let isValid = true;
  if (!email.value) {
    errors.value.email = 'Email is required';
    isValid = false;
  } else if (!isValidEmail(email.value)) {
    errors.value.email = 'Please enter a valid email address';
    isValid = false;
  }
  return isValid;
}
function isValidEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}
async function handleReset() {
  if (!validateForm()) return;
  loading.value = true;
  errorMessage.value = '';
  try {
    await apiClient.post('/auth/forgot-password', {
      email: email.value
    });
    successMessage.value = 'If your email exists in our system, you will receive a password reset link shortly.';
    email.value = '';
  } catch (error) {
    errorMessage.value = error.response?.data?.message || 'An error occurred. Please try again.';
  } finally {
    loading.value = false;
  }
}
</script>

<style scoped>
/* ...原有样式可复制过来... */
</style>
